import React, { useContext, useState, useEffect } from 'react'
import { useFormik } from 'formik'
import settingContext from '@/custom/context/setting/settingContext'
import { Modal, Backdrop, Fade } from '@mui/material'
import { Button } from '@mui/material'
import {
    currencyFormat,
    dateTimeFormatFunction,
} from '@/product/common/components'

const useStyles = (theme) => ({
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // padding: theme.spacing(1),
    },
    paper: {
        width: '100%',
        maxWidth: '55rem',
    },
})

const StatusHistory = (props) => {
    const classes = useStyles()
    const [bidPopUp, setBidPopUp] = useState({ popup: false, id: 0 })
    const settingContexts = useContext(settingContext)

    const {
        getUserWithdrawalDetails,
        withdrawal_data,
        postWithdrawalrequest,
        responseStatus,
    } = settingContexts

    let initialValues = {
        searchterm: '',
        page: 1,
        limit: 2,
        order: '',
        orderby: '',
        filters: {
            project_id: {
                value: props?.historyId,
                type: 'in',
                field: 'swr.id',
            },
        },
    }

    useEffect(() => {
        if (props?.historyId) {
            getUserWithdrawalDetails(initialValues) // Ensure you use `initialValues` instead of `values`
            setBidPopUp({ popup: true, id: props.historyId })
        }
    }, [props.historyId])

    let [viewProduct, setViewProduct] = useState([])

    useEffect(() => {
        if (withdrawal_data && props.historyId) {
            const data = withdrawal_data?.records[0]

            const dateFields = [
                'requested_date',
                'inprogress_date',
                'paid_date',
            ]

            const mappedData = dateFields
                .filter((dateField) => data[dateField] !== null) // Filter out null values
                .map((dateField) => ({
                    username: data.username,
                    seller_name: data.seller_name,
                    product_id: data.project_id, // This can be renamed to "product_id" if needed
                    amount: data.amount,
                    status:
                        dateField === 'requested_date'
                            ? 'Fund Requested'
                            : dateField === 'inprogress_date'
                            ? 'In Progress'
                            : 'Paid',
                    date_type: dateField.replace('_date', ''),
                    date: data[dateField],
                    market_status: data.market_status,
                }))

            setViewProduct(mappedData)
        }
    }, [withdrawal_data, props.historyId])

    return (
        <div>
            <Modal
                disablePortal
                disableEnforceFocus
                disableAutoFocus
                open={bidPopUp.popup}
                className={`${classes.modal} customModal`}
                closeAfterTransition
                BackdropComponent={Backdrop}
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={bidPopUp.popup}>
                    <div className="bidHistoryModal">
                        <div className={classes.paper}>
                            <div className="modal fade show custom-modal">
                                <div className="modal-dialog modal-lg">
                                    <div className="modal-content">
                                        <div className="modal-header">
                                            <h4 className="modal-title">
                                                {'Bid history'}
                                            </h4>
                                            <Button
                                                id="bidHistory_close"
                                                className="close"
                                                onClick={() => {
                                                    setBidPopUp({
                                                        popup: false,
                                                        id: 0,
                                                    })
                                                    props.closeFunction()
                                                }}
                                            >
                                                <span className="material-icons">
                                                    close
                                                </span>
                                            </Button>
                                        </div>
                                        <div className="modal-body cm-body table-responsive">
                                            <table className="table table-bordered">
                                                <thead>
                                                    <tr>
                                                        <th scope="col">
                                                            {'Username'}
                                                        </th>
                                                        <th scope="col">
                                                            {'Name'}
                                                        </th>
                                                        <th scope="col">
                                                            {'Product Id'}
                                                        </th>
                                                        <th scope="col">
                                                            {'Amount'}
                                                        </th>
                                                        <th scope="col">
                                                            {'Status'}
                                                        </th>
                                                        <th scope="col">
                                                            {'Date'}
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {viewProduct.map(
                                                        (data, index) => (
                                                            <>
                                                                <tr>
                                                                    <td>
                                                                        {
                                                                            data?.username
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            data?.seller_name
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            data?.product_id
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {currencyFormat(
                                                                            data?.amount
                                                                        )}
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            data?.status
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {dateTimeFormatFunction(
                                                                            data?.date
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            </>
                                                        )
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Fade>
            </Modal>
        </div>
    )
}

export default StatusHistory
